export const APP_VERSION = '2025.07.14';
